"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const AlertTitle_1 = __importDefault(require("@material-ui/lab/AlertTitle"));
const CheckCircleOutline_1 = __importDefault(require("@material-ui/icons/CheckCircleOutline"));
const ReportProblemOutlined_1 = __importDefault(require("@material-ui/icons/ReportProblemOutlined"));
const CancelOutlined_1 = __importDefault(require("@material-ui/icons/CancelOutlined"));
const InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const styles_1 = require("@material-ui/core/styles");
const Button_1 = __importDefault(require("../../../Button"));
const Box_1 = __importDefault(require("../../../../layouts/Box"));
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        borderRadius: 0,
    },
    muiAlertMessageOverride: {
        justifyContent: 'flex-start',
        borderRadius: 0,
    },
    childrenContainer: {
        flexDirection: 'row',
    },
    button: {
        '& .MuiButton-root': {
            backgroundColor: theme.palette.background.default,
        },
    },
    loading: {
        color: theme.palette.primary.contrastText,
    },
}));
const iconMapping = {
    success: react_1.default.createElement(CheckCircleOutline_1.default, { fontSize: "inherit", titleAccess: "success" }),
    warning: react_1.default.createElement(ReportProblemOutlined_1.default, { fontSize: "inherit", titleAccess: "warning" }),
    error: react_1.default.createElement(CancelOutlined_1.default, { fontSize: "inherit", titleAccess: "error" }),
    info: react_1.default.createElement(InfoOutlined_1.default, { fontSize: "inherit", titleAccess: "info" }),
};
const FlashbarItem = (_a) => {
    var { type = 'info', dismissible = false, loading = false, onDismiss, onButtonClick, buttonText, header, content } = _a, props = __rest(_a, ["type", "dismissible", "loading", "onDismiss", "onButtonClick", "buttonText", "header", "content"]);
    const styles = useStyles({});
    const [show, setShow] = react_1.default.useState(true);
    const id = useUniqueId_1.default(props.id);
    const testId = props['data-testid'] || `flashbar-item-${id}`;
    const actions = react_1.useMemo(() => {
        return (react_1.default.createElement(Box_1.default, { className: styles.button },
            buttonText && react_1.default.createElement(Button_1.default, { onClick: onButtonClick }, buttonText),
            dismissible && (react_1.default.createElement(IconButton_1.default, { "aria-label": "Close", "data-testid": `${testId}-dismiss-button`, onClick: () => {
                    onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                    setShow(false);
                } },
                react_1.default.createElement(Close_1.default, null)))));
    }, [buttonText, styles.button, onDismiss, onButtonClick, setShow, dismissible, testId]);
    const body = react_1.useMemo(() => {
        const props = Object.assign({ severity: loading ? 'info' : type, iconMapping, action: actions, 'data-testid': `${testId}-body` }, (loading && { icon: react_1.default.createElement(CircularProgress_1.default, { className: styles.loading, size: "16px" }) }));
        return (react_1.default.createElement(Paper_1.default, null,
            react_1.default.createElement(Alert_1.default, Object.assign({ variant: "filled" }, props, { classes: { root: styles.root, message: styles.muiAlertMessageOverride } }),
                header && (react_1.default.createElement(Box_1.default, { role: "heading", "aria-level": 1 },
                    react_1.default.createElement(AlertTitle_1.default, null, header))),
                react_1.default.createElement(Box_1.default, { className: styles.childrenContainer }, content))));
    }, [type, actions, header, content, loading, styles, testId]);
    return react_1.default.createElement(Box_1.default, { "data-testid": testId }, show && body);
};
exports.default = FlashbarItem;
//# sourceMappingURL=index.js.map